import ListItemTitleDescIcon from './list-item-title-desc-icon';

export default ListItemTitleDescIcon;
